




























import merge from "../utils/merge";
import defaultComponent from "../utils/defaultComponent";

export default defaultComponent.apply({
  props: [],
  data() {
    return {
      titleHTML: "",
      contentHTML: ""
    };
  },
  watch: {
    model: {
      handler(val) {
        if (val && val.value) {
          this.updateContext();
        }
      },
      deep: true
    }
  },
  methods: {
    initialize() {
      for (const key in this.options.content.buttons) {
        let button = this.options.content.buttons[key];
        if (!button.ignoreDefault) {
          button = merge.clone(this.options.content.template.button, button);
        }
        this.options.content.buttons[key] = button;
      }

      this.updateContext();
    },
    updateContext() {
      switch (typeof this.options.content.title.html) {
        case "function":
          this.titleHTML = this.options.content.title.html(this);
          break;
        default:
          this.titleHTML = this.options.content.title.html;
      }

      switch (typeof this.options.content.content.html) {
        case "function":
          this.contentHTML = this.options.content.content.html(this);
          break;
        default:
          this.contentHTML = this.options.content.content.html;
      }
    },
    show() {
      this.model.value = true;
    },
    hide() {
      this.model.value = false;
    },
    returnResult(result) {
      this.hide();
      this.emit("xResult", result);
      if (result) {
        this.emit("xYes");
      } else {
        this.emit("xNo");
      }
    }
  },
  extraOptions: {
    forwardStates: {
      xModel: ["model", false]
    },
    defaultClass: "confirmDialog"
  }
});
